import { render, staticRenderFns } from "./PlotCircularBuffer.vue?vue&type=template&id=2aaee881&scoped=true&"
import script from "./PlotCircularBuffer.vue?vue&type=script&lang=js&"
export * from "./PlotCircularBuffer.vue?vue&type=script&lang=js&"
import style0 from "./PlotCircularBuffer.vue?vue&type=style&index=0&id=2aaee881&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaee881",
  null
  
)

export default component.exports